import styled from 'styled-components';

export const ReportLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 10px;

  svg {
    width: 22px;
    height: 22px;
  }

  span {
    padding-left: 16px;
  }
`;
